// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

type ApiEnvelope<T> = {
  success?: boolean;
  status?: string;
  message?: string;
  token?: string;
  accessToken?: string;
  data?: T | { token?: string; accessToken?: string; user?: T };
};

/** 获取当前的用户 GET /api/current-user */
export async function currentUser(options?: { [key: string]: any }) {
  return request<ApiEnvelope<API.CurrentUser>>('/api/current-user', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取服务端版本 GET /api/version */
export async function queryAppVersion(options?: { [key: string]: any }) {
  return request<ApiEnvelope<API.VersionData>>('/api/version', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改密码接口 PUT /api/change-password */
export async function changePassword(
  body: API.ChangePasswordParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/api/change-password', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取 OTP 二维码 GET /api/otp/qrcode */
export async function getOtpQrCode(options?: { [key: string]: any }) {
  return request<API.CommonResult & { data?: API.OtpQrCodeData }>('/api/otp/qrcode', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 启用 OTP POST /api/otp/enable */
export async function enableOtp(body: API.OtpEnableParams, options?: { [key: string]: any }) {
  return request<API.CommonResult>('/api/otp/enable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 禁用 OTP POST /api/otp/disable */
export async function disableOtp(
  body: API.OtpDisableParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/api/otp/disable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    data: new URLSearchParams({
      password: body.password,
    }).toString(),
    ...(options || {}),
  });
}

export async function updateCurrentUserEmail(
  body: API.CurrentUserEmailUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/api/current-user/email', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deviceAuth(body:API.AuthParams,options?: { [key: string]: any }){

  return request<API.AuthResult>('/api/auth/device', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 检查用户是否启用了OTP GET /api/auth/check-otp-status */
export async function checkOtpStatus(
  params: { username: string },
  options?: { [key: string]: any }
) {
  return request<API.CommonResult & { data?: { otpEnabled: boolean; username: string } }>(
    '/api/auth/check-otp-status',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getByodSession(
  params: API.ByodSessionParams,
  options?: { [key: string]: any },
) {
  const query: Record<string, string> = {};
  if (params.sessionId) {
    query.sessionId = params.sessionId;
  }
  if (params.userIdentifier) {
    query['user-identifier'] = params.userIdentifier;
  }

  return request<API.CommonResult & { data?: API.ByodSessionData }>('/mdm/byod/session', {
    method: 'GET',
    params: query,
    ...(options || {}),
  });
}

export async function submitByodAuthentication(
  body: API.ByodLoginParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult & { data?: API.ByodLoginResult }>(
    '/mdm/authenticate-results',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      data: new URLSearchParams({
        sessionId: body.sessionId,
        verificationCode: body.verificationCode,
      }).toString(),
      ...(options || {}),
    },
  );
}

export async function sendByodAuthenticationCode(
  body: API.ByodSendCodeParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult & { data?: API.ByodSendCodeResult }>(
    '/mdm/authenticate-email-code',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

export async function getOAuth2AuthorizationContext(
  params: { requestId: string },
  options?: { [key: string]: any },
) {
  return request<{
    status?: string;
    message?: string;
    data?: {
      requestId: string;
      businessName?: string;
      businessDomainName?: string;
      clientId: string;
      redirectUri: string;
      prompt?: string;
      requestedScope: string;
      effectiveScope: string;
      requestedScopes: string[];
      effectiveScopes: string[];
      status: string;
    };
  }>('/api/oauth2/authorize/context', {
    method: 'GET',
    params: {
      request_id: params.requestId,
    },
    ...(options || {}),
  });
}

export async function resolveOAuth2AuthorizationFlow(
  body: { requestId: string; email: string },
  options?: { [key: string]: any },
) {
  return request<{
    status?: string;
    message?: string;
    data?: {
      requestId: string;
      email: string;
      flowType: 'LOGIN' | 'REGISTER';
    };
  }>('/api/oauth2/authorize/flow', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function sendOAuth2AuthorizationCode(
  body: {
    requestId: string;
    email: string;
    familyName?: string;
    givenName?: string;
    department?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    status?: string;
    message?: string;
    data?: {
      requestId: string;
      email: string;
      expireAt: string;
      resendAvailableAt: string;
      flowType: 'LOGIN' | 'REGISTER';
    };
  }>('/api/oauth2/authorize/send-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function submitOAuth2AuthorizationLogin(
  body: {
    requestId: string;
    email: string;
    verificationCode: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    status?: string;
    message?: string;
    data?: {
      requestId: string;
      redirectUrl: string;
    };
  }>('/api/oauth2/authorize/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}


